<template>
  <page-layout
      :title="tariff?tariff.name:'Tariff Detail page'"
      :breadcrumb="pageBreadcrumb"
      :status="pageStatus"
      :code="pageCode"
      :info-cards="pageInfoCards"
  >
    <template #actions>
      <md-button class="md-primary md-round" @click="goToEdit(tariff.id)">
        <md-icon>edit</md-icon>
        Edit
      </md-button>
      <md-button
          v-if="can('update-tariff')"
          class="md-round"
          :class="tariff.is_active ? 'md-warning' : 'md-success'"
          @click="toggleTariffStatus"
      >
        <md-icon>{{ tariff.is_active ? 'pause' : 'play_arrow' }}</md-icon>
        {{ tariff.is_active ? 'Deactivate' : 'Activate' }}
      </md-button>
      <md-button class="md-info md-round" @click="goBack">
        <md-icon>arrow_back</md-icon>
        Back
      </md-button>
    </template>

    <template #content>
      <nav-tabs-card>
        <template slot="content">
          <span class="md-nav-tabs-title"></span>
          <md-tabs class="md-info md-white" md-alignment="left">
            <md-tab id="tab-pages" md-label="Rates" md-icon="currency_exchange">
              <md-card>
                <md-card-content>
                  <div class="text-right" v-if="!isEditingNewTag">
                    <md-button v-if="can('create-activity-tariff')"
                               @click="addNewActivityTariffRate()" class="md-primary md-dense">
                      Add Tariff Rate
                    </md-button>
                  </div>
                  <div v-if="isEditingNewTag">
                    <md-card>
                      <form @submit.prevent="add">

                        <md-card-content>
                          <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                              Activity:
                            </label>
                            <div class="md-layout-item">
                              <select-input
                                  v-model="activityNewRate.activity_id"
                                  deselect-label="Can't remove this value"
                                  track-by="id"
                                  label=""
                                  placeholder="Select  Activity"
                                  :options="activityList"
                                  :allow-empty="false">
                              </select-input>
                            </div>
                          </div>

                          <br>
                          <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                              Amount
                            </label>
                            <div class="md-layout-item">
                              <md-field class="md-invalid">
                                <md-input v-model="activityNewRate.amount" type="number"
                                          step="0.01"
                                          required/>
                              </md-field>
                            </div>
                          </div>
                          <br>
                          <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                              Weekend Amount
                            </label>
                            <div class="md-layout-item">
                              <md-field class="md-invalid">
                                <md-input v-model="activityNewRate.weekend_amount"
                                          step="0.01"
                                          type="number" required/>
                              </md-field>
                            </div>
                          </div>
                          <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                              Active
                            </label>
                            <div class="md-layout-item">
                              <md-field>
                                <label>Select ...</label>
                                <md-select v-model="activityNewRate.is_active"
                                           name="is_active">
                                  <md-option value=1>Yes</md-option>
                                  <md-option value=0>No</md-option>
                                </md-select>
                              </md-field>
                            </div>
                          </div>
                        </md-card-content>
                        <md-card-actions md-alignment="right">
                          <md-button class="md-danger" @click="closeForm()">Close</md-button>
                          <md-button type="submit" class="md-success">Add Rate</md-button>
                        </md-card-actions>
                      </form>
                    </md-card>
                  </div>
                </md-card-content>
              </md-card>
              <hr>
              <md-table v-model="activityTariff" @md-selected="onSelect">
                <md-table-toolbar>
                  <md-field>
                    <label>Per page</label>
                    <md-select
                        v-model="pagination.perPage"
                        name="pages">
                      <md-option
                          v-for="item in pagination.perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                      >
                        {{ item }}
                      </md-option>
                    </md-select>
                  </md-field>

                  <md-field>
                    <md-input
                        v-model="query"
                        type="search"
                        class="mb-3"
                        clearable
                        style="width: 200px"
                        placeholder="Search ..."
                    >
                    </md-input>
                  </md-field>
                </md-table-toolbar>
                <md-table-row>
                  <md-table-cell>
                    <b>From</b>
                  </md-table-cell>
                  <md-table-cell>
                    <b>To</b>
                  </md-table-cell>
                  <md-table-cell><b>Activity</b></md-table-cell>
                  <md-table-cell><b>Amount</b></md-table-cell>
                  <md-table-cell><b>Weekend Amount</b></md-table-cell>
                  <md-table-cell><b>Update</b></md-table-cell>
                  <md-table-cell><b>Delete</b></md-table-cell>
                </md-table-row>
                <md-table-row v-for="rateData in table " :key="rateData.id">
                  <md-table-cell>
                    {{ rateData.start_date }}
                  </md-table-cell>
                  <md-table-cell>
                    {{ rateData.end_date }}
                  </md-table-cell>

                  <md-table-cell>
                    <p>
                      {{ rateData.activity_name }}
                    </p>
                  </md-table-cell>
                  <md-table-cell>
                    <div v-if="rateData.id == editID">
                      <md-field>
                        <md-input v-model="rateData.amount"
                                  :id="rateData.id"
                                  step="0.01"
                        />
                      </md-field>
                    </div>
                    <div v-else>
                      {{ formatCurrency(rateData.amount) }}
                    </div>
                  </md-table-cell>
                  <md-table-cell>
                    <div v-if="rateData.id == editID">
                      <md-field>
                        <md-input v-model="rateData.weekend_amount"
                                  :id="rateData.id"
                                  step="0.01"
                        />
                      </md-field>
                    </div>
                    <div v-else>
                      {{ formatCurrency(rateData.weekend_amount) }}
                    </div>
                  </md-table-cell>
                  <md-table-cell>
                    <div v-if="rateData.id  == editID">
                      <md-button @click="updateRateData(rateData)"
                                 class="md-just-icon md-simple md-primary">
                        <md-icon>
                          save
                        </md-icon>
                      </md-button>
                    </div>

                    <div v-else @click=setEditingRate(rateData.id)>
                      <md-button class="md-icon-button md-raised md-round md-info"
                                 style="margin: 0.2rem">
                        <md-icon>edit</md-icon>
                      </md-button>
                    </div>

                  </md-table-cell>
                  <md-table-cell>
                    <md-button
                        class="md-icon-button md-raised md-round md-danger"
                        @click="destroy(rateData.id)"
                        style="margin: 0.2rem"
                    >
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <md-card-actions md-alignment="space-between">
                <div class="">
                  <p class="card-category">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                  </p>
                </div>
                <pagination
                    class="pagination-no-border pagination-success"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                />
              </md-card-actions>
            </md-tab>
            <md-tab id="tab-stations" md-label="Stations" md-icon="home">
              <resource-table
                  ref="table"
                  :columns="stationTariffColumns"
                  :fetch-data="fetchStationTariffData"
                  :initial-sort="{ field: 'station_id', order: 'desc' }"
                  @load-error="handleTableError"
                  @row-click="goToActivateStationTariff(1)"
              >
                <template #cell-status="{ item }">
                  <md-chip :class="getStatusClass(item.status)">
                    {{ item.is_active }}
                  </md-chip>
                </template>

                <!-- Custom actions -->
                <template #actions="{ item }">
                  <md-button class="md-icon-button" @click="goToActivateStationTariff(item)">
                    <md-icon>toggle_on</md-icon>
                  </md-button>
                  <!--                  <md-button class="md-icon-button" @click="remove(item)">-->
                  <!--                    <md-icon>delete</md-icon>-->
                  <!--                  </md-button>-->
                </template>

                <!-- Empty state -->
                <template #empty>
                  <div class="empty-state">
                    <md-icon>inbox</md-icon>
                    <p>No station found for this tariff</p>
                    <md-button @click="$refs.table.reset">Clear Filters</md-button>
                  </div>
                </template>
              </resource-table>
            </md-tab>
            <md-tab id="tab-stats" md-label="Statis" md-icon="home">
              <div class="analytics-dashboard" v-if="tariff">

                <!-- SECTION 1: PER MAN HOUR ANALYTICS -->
                <md-card class="mb-4" v-if="tariff.hourly_avg_rate > 0">
                  <md-card-header><h4 class="title">Per Man Hour Operations</h4></md-card-header>
                  <md-card-content>
                    <div class="md-layout md-gutter text-center mb-3">
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Avg Hourly</div>
                        <div class="kpi-value">{{ formatCurrency(tariff.hourly_avg_rate) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Peak Hourly</div>
                        <div class="kpi-value text-success">{{ formatCurrency(tariff.hourly_max_rate) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Floor Hourly</div>
                        <div class="kpi-value text-danger">{{ formatCurrency(tariff.hourly_min_rate) }}</div>
                      </div>
                    </div>

                    <!-- Comparative slider against global hourly rates -->
                    <div class="comparison-bar-row">
          <span class="insight-text text-muted">
            Hourly rates sit <b>{{ hourlyComparison.percent }}% {{ hourlyComparison.label }}</b> than the market system average.
          </span>
                      <div class="tier-track mt-2">
                        <div class="tier-marker" :style="{ left: hourlyComparison.position + '%' }"></div>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>

                <!-- SECTION 2: PER WORK DONE FLAT RATES -->
                <md-card class="mb-4" v-if="tariff.flat_avg_rate > 0">
                  <md-card-header><h4 class="title">Per Work Done Operations</h4></md-card-header>
                  <md-card-content>
                    <div class="md-layout md-gutter text-center mb-3">
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Avg Fixed Cost</div>
                        <div class="kpi-value">{{ formatCurrency(tariff.flat_avg_rate) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Max Project Fee</div>
                        <div class="kpi-value text-success">{{ formatCurrency(tariff.flat_max_rate) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Min Project Fee</div>
                        <div class="kpi-value text-danger">{{ formatCurrency(tariff.flat_min_rate) }}</div>
                      </div>
                    </div>

                    <!-- Comparative slider against global fixed rates -->
                    <div class="comparison-bar-row">
          <span class="insight-text text-muted">
            Fixed prices sit <b>{{ flatComparison.percent }}% {{ flatComparison.label }}</b> than the market system average.
          </span>
                      <div class="tier-track mt-2">
                        <div class="tier-marker position-flat" :style="{ left: flatComparison.position + '%' }"></div>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>

                <!-- SECTION 2: PER WORK DONE FLAT RATES -->
                <md-card class="mb-4" v-if="tariff">
                  <md-card-header><h4 class="title">Global</h4></md-card-header>
                  <md-card-content>
                    <div class="md-layout md-gutter text-center mb-3">
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Avg Fixed Cost</div>
                        <div class="kpi-value">{{ formatCurrency(tariff.globalFlatAvg) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Max Project Fee</div>
                        <div class="kpi-value text-success">{{ formatCurrency(tariff.globalFlatMax) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Min Project Fee</div>
                        <div class="kpi-value text-danger">{{ formatCurrency(tariff.globalFlatMin) }}</div>
                      </div>
                    </div>

                    <div class="md-layout md-gutter text-center mb-3">
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Avg Hourly</div>
                        <div class="kpi-value">{{ formatCurrency(tariff.globalHourlyAverage) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Peak Hourly</div>
                        <div class="kpi-value text-success">{{ formatCurrency(tariff.globalHourlyMax) }}</div>
                      </div>
                      <div class="md-layout-item md-size-33">
                        <div class="kpi-label">Floor Hourly</div>
                        <div class="kpi-value text-danger">{{ formatCurrency(tariff.globalHourlyMin) }}</div>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>

              </div>

            </md-tab>

          </md-tabs>

        </template>
      </nav-tabs-card>
    </template>
  </page-layout>
</template>

<script>
import SelectInput from '../../../components/Inputs/SelectInput';
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import Swal from 'sweetalert2';
import {NavTabsCard,} from '@/components';
import ResourceTable from "@/components/Tables/ResourceTable.vue";
import pageMixin from "@/mixins/page-mixin";
import PageLayout from "@/components/Layouts/PageLayout.vue";

export default {
  components: {
    ResourceTable,
    SelectInput,
    PageLayout,
    NavTabsCard,
    pagination: Pagination,
  },
  mixins: [pageMixin],
  props: {
    profileCard: {
      type: String,
      default: process.env.VUE_APP_BASE_URL + '/img/faces/card-profile1-square.jpg'
    }
  },
  data() {
    return {
      editID: '',
      selected: [],
      improvedRates: [],
      activityList: [],
      vendorList: [],
      tariffActivities: [],
      responsive: false,
      isEditing: false,
      isEditingNewTag: false,
      tariff: {
        type: 'tariffs',
        name: null,
        id: null,
        description: null,
        is_active: null,
        hourly_avg_rate: 0,
        hourly_max_rate: 0,
        hourly_min_rate: 0,
        flat_avg_rate: 0,
        flat_max_rate: 0,
        flat_min_rate: 0,
        globalFlatAvg: 0,
        globalFlatMin: 0,
        globalFlatMax: 0,
        globalHourlyAverage: 0,
        globalHourlyMax: 0,
        globalHourlyMin: 0,
        weekend_markup_percent: 0,
        vendor: {type: 'vendors', name: null},
      },
      activity: {
        type: 'activities',
        name: null,
        id: null,
        pay_code: null,
        description: null,
        payment_mode: null
      },
      activityTariff: {
        type: 'activityTariffs',
        activity_id: null,
        activity_name: null,
        tariff_id: null,
        tariff_name: null,
        amount: null,
        weekend_amount: null,
        is_active: null,
        id: null
      },
      activityNewRate: {
        type: 'activityTariffs',
        activity_id: null,
        tariff_id: null,
        amount: null,
        weekend_amount: null,
        is_active: 1,
      },
      classicModal: false,
      noticeModal: false,
      smallAlertModal: false,
      totalStations: 0,
      table: [],
      footerTable: [
        'Tariff',
        'Activity',
        'Amount',
        'Weekend Amount',
        'Active',
        'From',
        'To'
      ],
      query: null,
      sortation: {
        field: null,
        order: 'asc',
      },
      stationTariffColumns: [
        {field: 'station.name', label: 'Station'},
        {field: 'is_active', label: 'Active'}
      ],

      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
      },
      total: 0,
    };
  },
  computed: {
    sort() {
      if (this.sortation.order === 'desc') {
        return `-${this.sortation.field}`;
      }
      return this.sortation.field;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    hourlyComparison: function () {
      if (!this.tariff) return { percent: 0, label: 'equal', position: 50 };

      // Map properties directly out of the flat tariff object context
      return this.calculateMetricDelta(
          this.tariff.hourly_avg_rate,
          this.tariff.globalHourlyAverage,
          this.tariff.globalHourlyMax,
          this.tariff.globalHourlyMin
      );
    },
    flatComparison: function () {
      if (!this.tariff) return { percent: 0, label: 'equal', position: 50 };

      return this.calculateMetricDelta(
          this.tariff.flat_avg_rate,
          this.tariff.globalFlatAverage,
          this.tariff.globalFlatMax,
          this.tariff.globalFlatMin
      );
    }
  },

  async created() {
    await this.get();
    await this.getTariffActivityRates();
    this.getActivities();
    this.getVendors();
    this.getVendors();
    this.initPage();
  },


  watch: {
    query: {
      handler: 'getListDebounced',
      immediate: true,
    },
    sortation: {
      handler: 'getList',
      immediate: false,
      deep: true,
    },
    pagination: {
      handler: 'getList',
      immediate: false,
      deep: true,
    },
    'tariff.id': {
      handler(newVal) {
        if (newVal) {
          // We use $nextTick to ensure the table component is actually
          // rendered in the DOM before we tell it to load.
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.getList();
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    initPage() {
      this.updatePageConfig({
        title: this.tariff.name || 'Tariff Details',
        breadcrumb: [
          {label: 'Tariffs', path: '/tariffs'},
          {label: this.tariff.name || 'Details'}
        ],
        status: {
          label: this.tariff.is_active ? 'Active' : 'Inactive',
          type: this.tariff.is_active ? 'success' : 'danger'
        },
        code: this.tariff.code ? `Code: ${this.tariff.code}` : null,
        infoCards: [
          {icon: 'store', label: 'Vendor', value: this.tariff.vendor ? this.tariff.vendor.name : 'N/A'},
          {icon: 'description', label: 'Description', value: this.tariff.description || 'No description'},
          {icon: 'attach_money', label: 'Rates', value: `${this.total} rates`},
          {icon: 'location_city', label: 'Stations', value: `${this.totalStations} stations`}
        ]
      });
    },
    closeForm() {
      this.isEditingNewTag = false;
    },
    async fetchData() {
      let params = {
        filter: {
          'hasNoTariff': this.tariff.id
        }
      };

      await this.$store.dispatch('activities/list', params);
      this.activityList = this.$store.getters['activities/list'];

      // await this.$store.dispatch('vendors/list', params);
      // this.vendorList = this.$store.getters['vendors/list'];
    },
    setEditingRate(rateId) {
      this.editID = rateId;
      this.isEditingNewTag = false;
    },
    async updateRateData(rateData) {
      rateData.type = 'activityTariffs';
      try {
        await this.$store.dispatch('activityTariffs/update', rateData);
        await this.$store.dispatch(
            'alerts/success',
            'Activity tariff updated successfully.'
        );
        await this.getList();

        this.editID = '';
      } catch (e) {
        console.log(e);
        if (e.response.data.errors[0]) {
          await this.$store.dispatch(
              'alerts/error',
              e.response.data.errors[0].title
          );
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch(
              'alerts/error',
              'Oops, something went wrong!'
          );
        }
      }
      this.editID = '';
    },
    goToEdit(id) {
      this.$router.push({name: 'Edit Tariff', params: {id}});
    },
    onSelect: function (items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch('tariffs/get', {id: id, include: 'vendor,stations'});
        this.tariff = this.$store.getters['tariffs/tariff'];
        await this.getList();
        await this.fetchData();
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },

    async getActivities() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch('tariffs/activities', id);
        this.activity = this.$store.getters['tariffs/list'];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },
    async getVendors() {
      try {
        await this.$store.dispatch('vendors/list');
        this.vendorList = this.$store.getters['vendors/list'];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },

    async getTariffActivityRates() {
      let params = {
        ...(this.sort ? {sort: this.sort} : {}),
        filter: {
          ...(this.query ? {name: this.query} : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };
      try {
        await this.$store.dispatch('tariffActivities/list', params);
        this.activityTariff = this.$store.getters['tariffActivities/list'];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },
    async update() {
      this.tariff.is_active = 1;
      try {
        await this.$store.dispatch('tariffs/update', this.tariff);
        await this.$store.dispatch(
            'alerts/success',
            'Tariff Activated successfully.'
        );
      } catch (e) {
        if (e.response.data.errors[0]) {
          await this.$store.dispatch(
              'alerts/error',
              e.response.data.errors[0].title
          );
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch(
              'alerts/error',
              'Oops, something went wrong!'
          );
        }
      }
    },
    goBack() {
      this.$router.push({name: 'Tariffs List'});
    },
    classicModalHide: function () {
      this.classicModal = false;
    },
    noticeModalHide: function () {
      this.noticeModal = false;
    },
    smallAlertModalHide: function () {
      this.smallAlertModal = false;
    },

    addNewActivityTariffRate() {
      this.isEditingNewTag = true;
    },
    async add() {
      this.isEditingNewTag = false;
      this.activityNewRate.tariff_id = this.tariff.id;
      this.activityNewRate.vendor_id = this.tariff.vendor_id;

      try {
        await this.$store.dispatch('tariffActivities/add', this.activityNewRate);
        this.notifySuccess('Tariff Activity  Rate added successfully.');
        await this.getList();
        this.activityNewRate.activity_id = null;
        this.activityNewRate.tariff_id = null;
        this.activityNewRate.amount = null;
        this.activityNewRate.weekend_amount = null;
        this.activityNewRate.is_active = 1;
        this.reload();
      } catch (e) {
        if (e.response.data.errors[0]) {
          await this.notifyError(e.response.data.errors[0].title);
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.notifyError('Oops, something went wrong!');
        }
      }
    },
    async destroy(Rate) {
      if (this.$isDemo == 1 && ['1'].includes(Rate)) {
        await this.$store.dispatch(
            'alerts/error',
            'You are not allowed to change data of default items.'
        );
        return;
      }
      const confirmation = await Swal.fire({
        title: 'Delete this Rate?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
      });

      if (confirmation.value === true) {
        try {
          await this.$store.dispatch('activityTariffs/destroy', Rate);
          await this.$store.dispatch(
              'alerts/success',
              'Tariff Rate deleted successfully.'
          );
          await this.getTariffActivityRates();
        } catch (e) {
          if (e.response.data.errors[0]) {
            await this.$store.dispatch(
                'alerts/error',
                e.response.data.errors[0].title
            );
          } else {
            this.notifyException(e);
          }
        }
      }
    },
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      let params = {
        ...(this.sort ? {sort: this.sort} : {}),
        filter: {
          ...(this.query ? {name: this.query} : {}),
          ...(this.tariff.id ? {tariff_id: this.tariff.id} : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      try {
        await this.$store.dispatch('activityTariffs/list', params);
        this.table = this.$store.getters['activityTariffs/list'];
        this.total = this.$store.getters['activityTariffs/listTotal'];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },
    async fetchStationTariffData(params) {
      if (!this.tariff || !this.tariff.id) {
        return {data: [], total: 0};
      }

      params = {
        include: 'station',
        filter: {
          tariff_id: this.tariff.id,
        }
      };
      try {
        await this.$store.dispatch('stationTariffs/list', params);
        this.totalStations = this.$store.getters['stationTariffs/listTotal'];
        return {
          data: this.$store.getters['stationTariffs/list'],
          total: this.$store.getters['stationTariffs/listTotal'],
        };
      } catch (e) {
        this.$store.dispatch('alerts/error', 'Failed to fetch station tariff');
        return {data: [], total: 0};
      }
    },
    handleTableError() {
      this.$store.dispatch('alerts/error', 'Failed to load data');
    },
    async goToActivateStationTariff(item) {
      // Determine the new state and text
      const isActivating = !item.is_active;
      const actionText = isActivating ? 'activate' : 'deactivate';
      const confirmButtonColor = isActivating ? '#4caf50' : '#f44336';

      // Show Confirmation Dialog
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `You are about to ${actionText} this station tariff.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: confirmButtonColor,
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, ${actionText} it!`
      });
      // dispatch the update
      if (result.value) {
        item.is_active = isActivating;
        try {
          // We pass the ID and the flipped is_active status
          await this.$store.dispatch('stationTariffs/update', item);

          Swal.fire(
              'Updated!',
              `Station tariff has been ${isActivating ? 'activated' : 'deactivated'}.`,
              'success'
          );

          // 4. Refresh the table data to show the new state
          this.$refs.table.getList();

        } catch (e) {
          Swal.fire('Error', 'Failed to update status.', 'error');
        }
      }
    },

    formatCurrency(val) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'TZS',
        maximumFractionDigits: 0
      }).format(val || 0);
    },
    async toggleTariffStatus() {
      const isActive = !!this.tariff.is_active; // Coerce to strict boolean
      const action = isActive ? 'deactivate' : 'activate';
      const actionPast = isActive ? 'deactivated' : 'activated';
      const icon = isActive ? 'warning' : 'success';
      const confirmButtonColor = isActive ? '#f44336' : '#4caf50';

      // 1. Show descriptive confirmation dialog
      const result = await Swal.fire({
        title: `${isActive ? 'Deactivate' : 'Activate'} Tariff?`,
        html: `
      <p>You are about to <strong>${action}</strong> this tariff.</p>
      <p style="color: #666; font-size: 14px;">
        Tariff: <strong>${this.tariff.name}</strong>
      </p>
      <p style="color: #666; font-size: 14px;">
        Current Status: <strong>${isActive ? 'Active' : 'Inactive'}</strong>
      </p>
      ${isActive
            ? '<p style="color: #f44336; font-size: 13px; margin-top: 10px;">⚠️ Deactivating this tariff will prevent it from being used in new assignments.</p>'
            : '<p style="color: #4caf50; font-size: 13px; margin-top: 10px;">✅ Activating this tariff will make it available for new assignments.</p>'
        }
    `,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: confirmButtonColor,
        cancelButtonColor: '#6c757d',
        confirmButtonText: `Yes, ${action} it!`,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
          confirmButton: 'md-button',
          cancelButton: 'md-button'
        },
        buttonsStyling: false
      });

      if (!result.isConfirmed) return;

      // 2. Display modal loading blocking state
      Swal.fire({
        title: `${isActive ? 'Deactivating' : 'Activating'}...`,
        text: `Please wait while we ${action} the tariff.`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      try {
        const updatedTariffPayload = {
          ...this.tariff,
          is_active: isActive ? 0 : 1
        };

        await this.$store.dispatch('tariffs/update', updatedTariffPayload);

        this.tariff.is_active = updatedTariffPayload.is_active;
        Swal.close();
        this.notifySuccess(`Tariff ${actionPast} successfully.`);

        // Refresh page data instance variables
        this.initPage();

      } catch (error) {
        this.notifyException(error);

        // Fixed grammar syntax error: Changed actionPast to dynamic present continuous string
        await Swal.fire({
          title: 'Error!',
          text: `Failed to ${action} the tariff. Please check your connection and try again.`,
          icon: 'error',
          confirmButtonColor: '#f44336',
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'md-button md-danger'
          },
          buttonsStyling: false
        });
      }
    },
    calculateMetricDelta: function (localAvg, gAvg, gMax, gMin) {
      var lAvg = parseFloat(localAvg) || 0;
      var globalAvg = parseFloat(gAvg) || 0;
      var globalMax = parseFloat(gMax) || 0;
      var globalMin = parseFloat(gMin) || 0;

      var diff = globalAvg > 0 ? Math.abs(((lAvg - globalAvg) / globalAvg) * 100) : 0;
      var range = globalMax - globalMin;
      var pos = range > 0 ? ((lAvg - globalMin) / range) * 100 : 50;

      return {
        percent: diff.toFixed(1),
        label: lAvg > globalAvg ? 'higher' : 'lower',
        position: Math.min(100, Math.max(0, Math.round(pos)))
      };
    }

  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },

};
</script>

<style lang="css">
.mb-4 { margin-bottom: 1.5rem; }
.mt-2 { margin-top: 0.5rem; }
.kpi-label { font-size: 0.75rem; color: #777; text-transform: uppercase; font-weight: bold; }
.kpi-value { font-size: 1.4rem; font-weight: bold; }
.tier-track { width: 100%; height: 6px; background: #e0e0e0; border-radius: 3px; position: relative; }
.tier-marker { position: absolute; width: 12px; height: 12px; background: #2196f3; border-radius: 50%; top: -3px; transform: translateX(-50%); }
.position-flat { background: #e91e63; }
</style>